export default __webpack_public_path__ + "static/media/present.15b93887.png";